/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is template in the master mix?`)
};

const es_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El molde va en el master mix?`)
};

const de_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist die Template-DNA im Mastermix enthalten?`)
};

const nl_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zit template in de mastermix?`)
};

const fr_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La matrice est-elle dans le mix maître ?`)
};

const it_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il template è nel master mix?`)
};

const pt_br2_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O molde está no master mix?`)
};

const pt_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O molde está na master mix?`)
};

const ja_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートはマスターミックスに含まれますか?`)
};

const zh_pcr_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板是否包含在混合液中？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_q3", locale)
	if (locale === "en") return en_pcr_faq_q3(inputs)
	if (locale === "es") return es_pcr_faq_q3(inputs)
	if (locale === "de") return de_pcr_faq_q3(inputs)
	if (locale === "nl") return nl_pcr_faq_q3(inputs)
	if (locale === "fr") return fr_pcr_faq_q3(inputs)
	if (locale === "it") return it_pcr_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_q3(inputs)
	if (locale === "pt") return pt_pcr_faq_q3(inputs)
	if (locale === "ja") return ja_pcr_faq_q3(inputs)
	return zh_pcr_faq_q3(inputs)
};